module.exports = __webpack_public_path__ + "static/img/5123.3fd0b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5123.png
// module id = f9jc
// module chunks = 0